import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Styles from "./Styles/Pages.module.css";
// import DownloadCard from "../../downloadCard/DownloadCard";
import convertNumbersToPersian from "../../../Utils/convertNumbersToPersian";
import { QuarterlyPageImagesContext } from "../../../Context/quarterlyPagesContext";
import { getQuarterlyPage } from "../../../Services/getData";

const QuarterlyPages = React.forwardRef(
  (
    {
      // title,
      // text,
      pageNumber,
      // handleSelectText,
      // downloadImage,
      // pageImage,
      page,
      currentPage,
      index,
      pagesLength,
      bookName,
      starterPage,
      isLoggedIn,
    },
    ref
  ) => {
    const { images, addImage } = useContext(QuarterlyPageImagesContext);
    const { quarterlyId } = useParams();
    const mainPage = pagesLength - index;
    const [currentImage, setCurrentImage] = useState();

    const [pageImage, setPageImage] = useState([]);

    // useEffect(() => {
    //   const api = async () => {
    //     try {
    //       const { data } = await getBookPage(bookId, pageNumber);
    //       const imageUrl = URL.createObjectURL(data);
    //       setPageImage(imageUrl);
    //     } catch (ex) {
    //       console.log(ex);
    //     }
    //   };
    //   api();
    // }, []);

    useEffect(() => {
      const fetchPageImage = async () => {
        try {
          const { data: firstImage } = await getQuarterlyPage(
            quarterlyId,
            images.length === 0
              ? starterPage === 0
                ? starterPage + 1
                : starterPage - 1
              : pageNumber
          );
          const imageUrl = URL.createObjectURL(firstImage);
          addImage({
            imageUrl,
            pageNumber:
              images.length === 0
                ? starterPage === 0
                  ? starterPage + 1
                  : starterPage - 1
                : pageNumber,
          });

          const { data: secondImage } = await getQuarterlyPage(
            quarterlyId,
            images.length === 0
              ? starterPage === 0
                ? starterPage + 2
                : starterPage
              : pageNumber + 1
          );
          const secondImageUrl = URL.createObjectURL(secondImage);
          addImage({
            imageUrl: secondImageUrl,
            pageNumber:
              images.length === 0
                ? starterPage === 0
                  ? starterPage + 2
                  : starterPage
                : pageNumber + 1,
          });
          return;
        } catch (ex) {
          console.error(ex);
        }
      };
      if (
        images.length === 0 ||
        (!images.some((item) => item.pageNumber === pageNumber) &&
          !images.some((item) => item.pageNumber === pageNumber + 1))
      ) {
        if (
          currentPage + 1 === pageNumber ||
          currentPage === pageNumber ||
          starterPage === pageNumber
        ) {
          fetchPageImage();
        }
      }
    }, [currentPage, pageNumber, quarterlyId, images, addImage]);

    useEffect(() => {
      const imageIndex = images.findIndex((i) => i.pageNumber === pageNumber);
      if (imageIndex !== -1) {
        setCurrentImage(images[imageIndex].imageUrl);
      }
    }, [images, pageNumber]);

    // const downloadPageImage = (e) => {
    //   e.preventDefault();
    //   const link = document.createElement("a");
    //   link.href = currentImage;
    //   link.download = `${bookName} : صفحه ${mainPage}`;
    //   link.style.display = "none";
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    // };

    return (
      <div ref={ref} className={Styles.container}>
        {/* <div
          style={{
            position: "absolute",
            zIndex: -10,
            right: 100000,
            top: -10000,
          }}
        >
          <DownloadCard
            bookName="موفقیت در 30 روز"
            pageNumber={pageNumber}
            text={text}
            // writerName={writerName}
            // translatorName={translatorName}
            ref={downloadRef}
          />
        </div> */}
        {/* <div className={Styles.top}> */}
        {/* <button onClick={() => handleSelectText(text, downloadRef)}>
            انتخاب متن
          </button> */}
        {/* <button onClick={downloadPageImage}>فیش برداری</button> */}
        {/* </div> */}
        <h2 className={Styles.pageNumber}>
          {convertNumbersToPersian(String(pageNumber))}
        </h2>
        {currentImage && <img alt="" src={currentImage && currentImage} />}
      </div>
    );
  }
);

export default QuarterlyPages;
